import { Block } from "@components/block";
import { EllipsisText } from "@components/ellipsis-text";
import { Config, Table } from "@components/table";
import { ReferralDetails } from "@features/admin/users/api";
import { useLead } from "@features/lead";
import { formatDate } from "@helpers/date";
import { useEffect } from "react";

const config: Config<ReferralDetails> = [
  {
    label: "Id",
    source: "referral_id",
    renderComponent: (data) => (
      <EllipsisText text={data} startLength={10} endLength={10} copy />
    ),
  },
  { label: "Почта", source: "referral_email" },
  {
    label: "Дата регистрации",
    source: "linked_date",
    renderComponent: (data) =>
      formatDate(new Date(data)),
      //   <DoubleText
      //     text={formatDate(new Date(data))}
      //     subText={formatTime(new Date(data))}
      //   />
  },
  // { label: "pay_in", source: "earned_from_pay_in" },
  // { label: "pay_out", source: "earned_from_pay_out" },
  { label: "Доход", source: "total_earned" },
];

export const PartnersPage = () => {
  const { state, getLeadPartners } = useLead();
  useEffect(() => {
    getLeadPartners();
  }, [getLeadPartners]);
  return (
    <Block>
      <Table title="Партнеры" config={config} data={state.partners} loading={state.loading} />
    </Block>
  );
};
